<template>
  <div id="enterprise-agency-form">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center mb-base">
        <div class="flex-grow">
          <div class="insert-data-container">
            <div class="input-area">
              <div class="title-area">
                <span class="title">代理店（法人）情報</span>
                <div v-if="isViewMode" class="back-button" @click="backToMaster">
                  <feather-icon icon="ChevronLeftIcon" svgClasses="h-5 w-5" />
                  <span>一覧へ戻る</span>
                </div>
              </div>
              <div class="input-group">
                <div class="input-column left-column">
                  <div class="input-row">
                    <div class="string-input">
                      <div class="label">
                        <span class="label">{{inputs.name.label}}</span>
                        <span v-if="!isViewMode" class="validation-label">*</span>
                      </div>
                      <span v-if="isViewMode">{{inputs.name.value}}</span>
                      <vs-input
                        v-else
                        class="name-input"
                        color="#2D9CDB"
                        v-model="inputs.name.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.nameEn.label}}</span>
                      <span v-if="isViewMode">{{inputs.nameEn.value}}</span>
                      <vs-input
                        v-else
                        class="name_en-input"
                        color="#2D9CDB"
                        v-model="inputs.nameEn.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <div class="label">
                        <span class="label">{{inputs.shortName.label}}</span>
                        <span v-if="!isViewMode" class="validation-label">*</span>
                      </div>
                      <span v-if="isViewMode">{{inputs.shortName.value}}</span>
                      <vs-input
                        v-else
                        class="short_name-input"
                        color="#2D9CDB"
                        v-model="inputs.shortName.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.billingAddress.label}}</span>
                      <span v-if="isViewMode">{{inputs.billingAddress.value}}</span>
                      <vs-input
                        v-else
                        class="billing_address-input"
                        color="#2D9CDB"
                        v-model="inputs.billingAddress.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.tel.label}}</span>
                      <span v-if="isViewMode">{{inputs.tel.value}}</span>
                      <vs-input
                        v-else
                        class="tel-input"
                        color="#2D9CDB"
                        v-model="inputs.tel.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row" v-if="isViewMode || isEditMode">
                    <div class="string-input">
                      <span class="label">{{inputs.created_at.label}}</span>
                      <span>{{convertedCreatedAt}}</span>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="text-area-input">
                      <span class="label">{{inputs.description.label}}</span>
                      <span v-if="isViewMode">{{inputs.description.value}}</span>
                      <vs-textarea
                        v-else
                        class="description-input"
                        width="300px"
                        v-model="inputs.description.value"
                      ></vs-textarea>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.ports.label}}</span>
                      <span v-if="isViewMode" class="port-area">
                        <template
                          v-for="(port, index) in inputs.ports.value"
                        >
                          <div 
                            :key="index"
                            class="multiselect__tag read-only-tag"
                            style="background:#2D9CDB;"
                          >
                            {{port.name}}
                          </div>
                        </template>
                      </span>
                      <div v-else class="port-input">
                        <multiselect 
                          v-model="inputs.ports.value"
                          tag-placeholder="港湾が見つかりません"
                          placeholder="港湾を追加できます"
                          selectLabel="選択する"
                          selectedLabel="選択済"
                          deselectLabel="削除する"
                          label="name"
                          track-by="id"
                          :options="portOptions"
                          :multiple="true"
                          :taggable="true"
                        >
                          <template slot="tag" slot-scope="props">
                            <span class="multiselect__tag" style="background:#2D9CDB;">
                              <span>{{props.option.name}}</span>
                              <i tabindex="1"
                                @keypress.enter.prevent="removeTagById(props.option.id)"
                                @mousedown.prevent="removeTagById(props.option.id)"
                                class="multiselect__tag-icon">
                              </i>
                            </span>
                          </template>
                        </multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{inputs.adminCode.label}}</span>
                      <span v-if="isViewMode">{{inputs.adminCode.value}}</span>
                      <vs-input
                        v-else
                        class="admin_code-input"
                        color="#2D9CDB"
                        v-model="inputs.adminCode.value"
                      ></vs-input>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="isViewMode">
                <vs-button color="#2D9CDB" @click="isEditing = true">編集</vs-button>
                <vs-button class="insert-button" color="#BDBDBD" @click="popupActive=true">削除</vs-button>
              </template>
              <template v-else-if="isEditMode">
                <vs-button color="#BDBDBD" @click="cancelEdit">キャンセル</vs-button>
                <vs-button class="insert-button" :disabled="!activeInsertButton" color="#2D9CDB" @click="updateData">保存</vs-button>
              </template>
              <template v-else>
                <vs-button color="#BDBDBD" :to="{name: 'addon-port-master-enterprise-agency-master'}">キャンセル</vs-button>
                <vs-button class="insert-button" :disabled="!activeInsertButton" color="#2D9CDB" @click="insertData">登録</vs-button>
              </template>
            </div>
          </div>
        </div>
      </div>
      <vs-popup class="basic-master-popup"  title="代理店（法人）の削除" :active.sync="popupActive">
        <p>
          「{{inputs.name.value}}」を削除してよろしいですか？
        </p>
        <div class="button-area">
          <vs-button class="popup-button" color="#BDBDBD" @click="popupActive = false">キャンセル</vs-button>
          <vs-button class="popup-button" color="#2D9CDB" @click="callDelete">削除</vs-button>
        </div>
      </vs-popup>
      <error-dialog
        ref="errorDialog"
      ></error-dialog>
    </div>
  </div>
</template>

<script>

import ErrorDialog from "../components/ErrorDialog";
import Multiselect from 'vue-multiselect';
import { createNamespacedHelpers } from "vuex";
import moment from 'moment';
const { mapActions, mapState } = createNamespacedHelpers("portMaster");

export default {
  components: {
    Multiselect,
    ErrorDialog,
  },
  props: {
    mode: { type: String, required: true }, // "view" or "insert"
  },
  data() {
    return {
      isEditing: false,
      inputs: {
        name: {
          label: "代理店名",
          value: null,
          originalValue: null,
        },
        nameEn: {
          label: "英字名称",
          value: null,
          originalValue: null,
        },
        shortName: {
          label: "略称",
          value: null,
          originalValue: null,
        },
        billingAddress: {
          label: "請求先",
          value: null,
          originalValue: null,
        },
        tel: {
          label: "電話番号",
          value: null,
          originalValue: null,
        },
        created_at: {
          label: "登録日",
          value: null,
          originalValue: null,
        },
        description: {
          label: "備考",
          value: null,
          originalValue: null,
        },
        ports: {
          label: "港湾",
          value: [],
          originalValue: []
        },
        adminCode: {
          label: "管理コード",
          value: null,
          originalValue: null,
        },
      },
      version: null,
      inputValues: [],
      popupActive: false,
    }
  },
  async created() {
    this.$vs.loading()
    await this.fetchPorts()

    if (this.isViewMode) {
      let payload = {
        id: this.$route.params.itemId,
      }
      
      let res = await this.fetchEnterpriseAgencyDetail(payload)
      let enterpriseAgencies = res.shipping_agency
      
      this.inputs.name.value = enterpriseAgencies.name
      this.inputs.nameEn.value = enterpriseAgencies.name_en
      this.inputs.shortName.value = enterpriseAgencies.short_name
      this.inputs.billingAddress.value = enterpriseAgencies.billing_address
      this.inputs.tel.value = enterpriseAgencies.tel
      this.inputs.created_at.value = enterpriseAgencies.created_at
      this.inputs.description.value = enterpriseAgencies.description
      this.inputs.adminCode.value = enterpriseAgencies.admin_code
      this.inputs.ports.value = enterpriseAgencies.ports.map(element => {
        return {
          id: element.id,
          name: element.port.name
        }
      })

      this.version = enterpriseAgencies.version

      Object.keys(this.inputs).forEach(key => {
        this.inputs[key].originalValue = this.inputs[key].value
      })
    }
    this.$vs.loading.close()
  },
  computed: {
    ...mapState({
      portOptions: state => state.portOptions,
    }),
    isViewMode() {
      return this.mode == "view" && !this.isEditing
    },
    isEditMode() {
      return this.isEditing
    },
    convertedCreatedAt() {
      return this.inputs.created_at.value ? moment(this.inputs.created_at.value).format('YYYY-MM-DD') : null
    },
    activeInsertButton() {
      let regex = /.+/
      if (!this.inputs.name.value || !this.inputs.shortName.value) return false
      return this.inputs.name.value.match(regex) && this.inputs.shortName.value.match(regex)
    }
  },
  methods: {
    ...mapActions(["insertEnterpriseAgency", "fetchPorts", "fetchEnterpriseAgencyDetail", "updateEnterpriseAgency", "deleteEnterpriseAgency"]),
    cancelEdit() {
      this.isEditing = false
      Object.keys(this.inputs).forEach(key => {
        this.inputs[key].value = this.inputs[key].originalValue
      })
    },
    backToMaster() {
      this.$router.push(
        {
          name: "addon-port-master-enterprise-agency-master"
        }
      )
    },
    removeTagById(id){
      this.inputs.ports.value = this.inputs.ports.value.filter(option => option.id != id)
    },
    async callDelete() {
      this.popupActive = false
      let payload = {
        id: this.$route.params.itemId,
      }
      try {
        this.$vs.loading()
        await this.deleteEnterpriseAgency(payload)
        this.$vs.loading.close()
        this.$vs.notify({
          title: "データを削除しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
        this.$router.push(
          {
            name: "addon-port-master-enterprise-agency-master"
          }
        )
      } catch(e) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: "データを更新できませんでした。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        })
      }
    },
    async updateData() {
      let name = this.inputs.name.value
      let name_en = this.inputs.nameEn.value
      let short_name = this.inputs.shortName.value
      let tel = this.inputs.tel.value
      let description = this.inputs.description.value
      let billing_address = this.inputs.billingAddress.value
      let admin_code = this.inputs.adminCode.value
      let port_ids = this.inputs.ports.value.map(element => element.id)

      let payload = {
        id: this.$route.params.itemId,
        body: {
          name: name,
          name_en: name_en,
          short_name: short_name,
          tel: tel,
          description: description,
          billing_address: billing_address,
          admin_code: admin_code,
          port_ids: port_ids,

          version: this.version
        }
      }

      try {
        this.$vs.loading()
        await this.updateEnterpriseAgency(payload)
        this.$vs.notify({
          title: "データを更新しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        })
        this.$router.push(
          {
            name: "addon-port-master-enterprise-agency-master"
          }
        )
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let label = this.inputs[element.target].label
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.errorDialog.open("エラー", null, validationErrors)
        } else {
          this.$refs.errorDialog.open("エラー", error.message, null)
        }
      }
      this.$vs.loading.close()
    },
    async insertData() {
      let name = this.inputs.name.value
      let name_en = this.inputs.nameEn.value
      let short_name = this.inputs.shortName.value
      let tel = this.inputs.tel.value
      let description = this.inputs.description.value
      let billing_address = this.inputs.billingAddress.value
      let admin_code = this.inputs.adminCode.value
      let port_ids = this.inputs.ports.value.map(element => element.id)

      let payload = {
        body: {
          name: name,
          name_en: name_en,
          short_name: short_name,
          tel: tel,
          description: description,
          billing_address: billing_address,
          admin_code: admin_code,
          port_ids: port_ids,

          version: this.version
        }
      }
      try {
        this.$vs.loading()
        await this.insertEnterpriseAgency(payload)
        this.$vs.notify({
          title: "データを追加しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        })
        this.$router.push(
          {
            name: "addon-port-master-enterprise-agency-master"
          }
        )
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let label = this.inputs[element.target].label
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.errorDialog.open("エラー", null, validationErrors)
        } else {
          this.$refs.errorDialog.open("エラー", error.message, null)
        }
      }
      this.$vs.loading.close()
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#enterprise-agency-form {
  .vs-con-textarea {
    margin: 0px;
  }
  .vx-card {
    min-width: 1100px;
  }
  .insert-data-container {
    display: flex;
    justify-content: space-between;
  }
  .title-area {
    display: flex;
  }
  .title {
    font-size: 18px;
  }
  .title-area {
    display: flex;
  }
  .back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 30px;
    color: #2D9CDB;
    cursor: pointer;
  }
  .input-area {
    width: 100%;
  }
  .input-group {
    width: 100%;
    display: flex;
  }
  .input-column {
    width: 500px;
  }
  .right-column {
    margin-left: 60px;
  }
  .small-input-row {
    display: flex;
    justify-content: space-between;
  }
  .required-note-input {
    flex-grow: 1;
  }
  .input-row {
    margin: 20px 0px;
  }
  .string-input, .color-input, .select-input {
    height: 42px;
    display: flex;
    align-items: center;
  }
  .text-area-input {
    display: flex;
  }
  .port-area {
    line-height: 1;
  }
  .read-only-tag {
    margin-bottom: 0px;
  }
  .multiselect__tag-icon:hover {
    background: $pm-mouse-gray;
  }
  .multiselect__option--selected {
    background: $pm-blue;
    color: $pm-white;
    &:after {
      background: $pm-blue;
      color: $pm-white;
    }
  }
  .multiselect__option {
    font-weight: normal !important;
  }
  .multiselect__option--selected.multiselect__option--highlight {
    background: $pm-mouse-gray;
    color: $pm-white;
    &:after {
      background: $pm-mouse-gray;
      color: $pm-white;
    }
  }
  .multiselect__option--highlight {
    background: $pm-light-blue;
    color: $pm-blue;
    &:after {
      background: $pm-light-blue;
      color: $pm-blue;
    }
  }
  .multiselect__tag-icon:after {
    color: $pm-black;
  }
  .label-input, .name-input {
    width: 300px;
  }
  .number-input {
    width: 40px;
  }
  .label {
    width: 110px;
  }
  .validation-label {
    color: red;
    margin-left: 4px;
  }
  .insert-button {
    margin-top: 10px;
    margin-left: 10px;
  }
}
</style>
